module.exports = __webpack_public_path__ + "img/pic5-2.c36e6073.png";